<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">add_comment</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Criar oportunidade</h2>
    <span class="modal-subtitle">{{ subtitulo }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" [disabled]="isCriando"
      (click)="fechar()" matTooltip="Fechar" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (isLoading) {
    <app-loading-box height="56" width="100%" marginTop="8"></app-loading-box>
    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
  } @else {
    <div class="row g-3 cod-campos">
      <!-- CA-69: avisa sem bloquear e oferece vincular à oportunidade que já existe. -->
      @if (oportunidadesEmAndamento.length) {
        <div class="col-12">
          <app-alert-card type="info" [title]="tituloAvisoEmAndamento">
            {{ textoAvisoEmAndamento }}
            @if (data.podeVincular) {
              <button alertActions mat-button type="button" class="btn-link" [disabled]="isCriando"
                (click)="irParaVincular()">Vincular a ela</button>
            }
          </app-alert-card>
        </div>
      }

      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Assunto</mat-label>
          <input matInput [formControl]="tituloControl" maxlength="120" required />
          <mat-error>Informe o assunto.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <!-- O cliente é o do documento: a oportunidade nasce com ele (RX-01). -->
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Cliente</mat-label>
          <input matInput [value]="data.nomeCliente" disabled />
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          [control]="vendedorControl"
          [offlineList]="opcoesVendedor"
          [preloadedOptions]="opcoesVendedor"
          [idField]="'idVendedor'"
          [nameField]="'nome'"
          [label]="'Vendedor responsável'"
          [hint]="hintVendedor"
          [disabled]="isCriando"
          subscriptSizing="dynamic">
        </app-select-pesquisavel>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Origem do lead</mat-label>
          <mat-select [formControl]="origemLeadControl" required>
            @for (origem of origensLead; track origem.id) {
              <mat-option [value]="origem.id">{{ origem.descricao }}</mat-option>
            }
          </mat-select>
          <mat-error>Informe a origem do lead.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-12">
        <p class="cod-apoio">
          A oportunidade nasce na primeira etapa do quadro, vinculada a este documento. O valor passa a vir do documento.
        </p>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isCriando" (click)="fechar()">
    Cancelar
  </button>
  <span [matTooltip]="motivoBloqueio" [matTooltipDisabled]="!motivoBloqueio || isCriando || isLoading">
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isCriando"
      [disabled]="!!motivoBloqueio || isCriando || isLoading"
      [attr.aria-label]="isCriando ? 'Criando' : (motivoBloqueio || 'Criar e vincular')" (click)="criar()">
      <mat-icon class="material-symbols-outlined">add_link</mat-icon>
      Criar e vincular
      @if (isCriando) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
  </span>
</mat-dialog-actions>
